var map = {
	"./searchResults.ca.json": [
		8953,
		953
	],
	"./searchResults.en.json": [
		1818,
		818
	],
	"./searchResults.es.json": [
		6505,
		505
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1200;
module.exports = webpackAsyncContext;